import { Expression } from "./abstract.expression";

export interface ODataApplyAggregate {
    field: string;
    type: string;
    alias: string;
}

export class ApplyExpression implements Expression 
{
    constructor(public aggregates: ODataApplyAggregate[]) {}

    toQuery(): string 
    {
        let filter = "$apply=aggregate(";
        this.aggregates.forEach(aggregate => 
        {
            filter += `${aggregate.field} with ${aggregate.type} as ${aggregate.alias},`;
        });
        return filter.substring(0, filter.length - 1) + ")";
    }
}
